<template>
 <div class="col-12 d-flex flex-column justify-content-center mt-2">
    <label class="form-label fs-6 fw-bolder text-black"> {{ $t('budgets.receipts') }}<span class="text-danger">*</span> </label>
    <input
        class="d-none"
        ref="fileInput"
        type="file"
        :name="`reason-${id}-file`"
        :id="`input-${id}-reason-file`"
        @change="handleUpload"
    />
    <div> 
        <button class="btn btn-sm btn-light-primary rounded w-150px h-35px" type="button" @click.prevent="triggerFileInput">
        <i class="bi bi-paperclip fs-4"></i>
        {{ $t('expense.label.attachFiles') }}
        </button>
        <small class="ms-2"> {{ $t('expense.placeholder.attachFiles') }} </small>
        <div class="d-flex flex-wrap mt-3">
        <Card class="mx-2" v-for="(file, index) in model">
            <div class="d-flex justify-content-between align-items-center p-3">
            <i class="bi bi-file-earmark text-primary fs-4 me-3"></i>
            {{ file.name }}
            <i class="bi bi-x fs-2 ms-3 cursor-pointer" @click.prevent="removeFile(index, file)"></i>
            </div>
        </Card>
        </div>
    </div>  
</div>    
</template>
  
  <script setup>
  
  import { defineEmits, ref} from "vue";
  import Card from "@/components/Card.vue";
  
  const model = defineModel({default: []})

  const props = defineProps({
    id: {type: String, default:"unique"},
  })
  const file = ref('')
  
  const handleUpload = (e) => {
    model.value = [...model.value, e.target.files[0]] 
    file.value = ''
  }
 
  const triggerFileInput = () => {
    $(`#input-${props.id}-reason-file`).click()
  }
  
  const removeFile = (index, file) => {
    model.value.splice(index, 1)
  }
  
  </script>
  
  <style scoped>
  </style>
  